import { AnyAction } from 'redux';
import { DraftConfiguration, StoreFontFamily } from '@/types';
import { isDraftSpecialTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { ensureFontIsAddedToDocumentAction } from '@/redux/core/actions/ensureFontIsAddedToDocumentAction';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { getConfiguration } from '@/redux/draft/getters/getConfiguration';
import { Thunk } from '@/redux/types';
import { convertSpecialTextToTextAction } from '@/components/draft/draftState/actions/convertSpecialTextToTextAction';

export const convertSpecialTextToTextConfigurationAction =
  (
    configuration: DraftConfiguration,
    fontFamily: StoreFontFamily
  ): Thunk<Promise<void>, AnyAction> =>
  async (dispatch, getState) => {
    const font =
      fontFamily.fonts.find((f) => f.style === 'normal' && f.weight === 'normal') ||
      fontFamily.fonts[0];

    const loadedFont = await dispatch(ensureFontIsAddedToDocumentAction(font));

    // it is possible for the user to remove the configuration before the font is loaded
    const state = getState();
    configuration = getConfiguration(state, configuration.cid);
    if (isDraftSpecialTextConfiguration(configuration)) {
      getDraftDispatch(state)(convertSpecialTextToTextAction(configuration, loadedFont));
    }
  };
